import React from 'react';

import { Menu as MenuStyled } from './DropdownButtonStyles';


export const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }: any, ref: any) => {
    const data: any = React.Children.toArray(children);

    return (
      <MenuStyled
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        {data.filter((child: any) => child.props.children)}
      </MenuStyled>
    );
  },
);
